import connectionProxy from '../connectionProxy'

export const authenticate = ({ email, password }) => {
  return connectionProxy.post('auth/sign_in', { email, password })
}
